var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityTestPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H10L9.425 9.775C9.75833 9.60833 10.0208 9.36667 10.2125 9.05C10.4042 8.73333 10.5 8.38333 10.5 8C10.5 7.45 10.3042 6.97917 9.9125 6.5875C9.52083 6.19583 9.05 6 8.5 6C7.95 6 7.47917 6.19583 7.0875 6.5875C6.69583 6.97917 6.5 7.45 6.5 8C6.5 8.38333 6.59583 8.73333 6.7875 9.05C6.97917 9.36667 7.24167 9.60833 7.575 9.775L7 13ZM8.5 20C6.18333 19.4167 4.27083 18.0875 2.7625 16.0125C1.25417 13.9375 0.5 11.6333 0.5 9.1V3L8.5 0L16.5 3V9.1C16.5 11.6333 15.7458 13.9375 14.2375 16.0125C12.7292 18.0875 10.8167 19.4167 8.5 20ZM8.5 17.9C10.2333 17.35 11.6667 16.25 12.8 14.6C13.9333 12.95 14.5 11.1167 14.5 9.1V4.375L8.5 2.125L2.5 4.375V9.1C2.5 11.1167 3.06667 12.95 4.2 14.6C5.33333 16.25 6.76667 17.35 8.5 17.9Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTestPlan);
export default __webpack_public_path__ + "static/media/SecurityTestPlan.9995180d9a49fe72d3cf99c91b7475be.svg";
export { ForwardRef as ReactComponent };